import { useEffect, useState } from "react"

// This should correspond to the breakpoints in our Tailwind theme
const breakpoints = {
  sm: "(min-width: 640px)",
  md: "(min-width: 900px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1280px)",
}

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl"

export const useBreakpoint = () => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<Breakpoint | null>(null)

  useEffect(() => {
    // Create a map of media query listeners
    const mediaQueryLists = Object.entries(breakpoints).map(([key, query]) => ({
      key,
      mediaQueryList: window.matchMedia(query),
    }))

    // Function to determine the largest active breakpoint
    const getActiveBreakpoint = () => {
      let largestMatchingBreakpoint: Breakpoint | null = null

      for (const { key, mediaQueryList } of mediaQueryLists) {
        if (mediaQueryList.matches) {
          largestMatchingBreakpoint = key as Breakpoint
        }
      }

      // Default to "xs" if no other breakpoints match
      setCurrentBreakpoint(largestMatchingBreakpoint || "xs")
    }

    // Initial check
    getActiveBreakpoint()

    mediaQueryLists.forEach(({ mediaQueryList }) => mediaQueryList.addEventListener("change", getActiveBreakpoint))

    return () => {
      mediaQueryLists.forEach(({ mediaQueryList }) => mediaQueryList.removeEventListener("change", getActiveBreakpoint))
    }
  }, [])

  return currentBreakpoint
}
